(function(){
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'obliq_wishlist';

  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function parse(html){ return new DOMParser().parseFromString(html, 'text/html'); }
  function esc(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function rupees(paise){ return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  function withSection(url, id){ return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id; }

  // ---------- dialogs ----------
  function openDialog(d){
    if (!d) return;
    if (!d.open) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); }
    document.body.classList.add('o-modal-open');
  }
  function closeDialog(d){
    if (!d || !d.open) return;
    if (d.close) d.close(); else d.removeAttribute('open');
  }
  $$('.o-modal').forEach(function(d){
    d.addEventListener('close', function(){ if (!$$('.o-modal').some(function(x){ return x.open; })) document.body.classList.remove('o-modal-open'); });
    d.addEventListener('click', function(e){ if (e.target === d) closeDialog(d); }); // click on backdrop
  });

  // ---------- wishlist ----------
  function getW(){ try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setW(a){ try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} syncW(); }
  function syncW(){
    var w = getW();
    $$('[data-o-wish]').forEach(function(b){
      var on = w.indexOf(b.getAttribute('data-o-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.getAttribute(on ? 'data-label-remove' : 'data-label-add');
      if (label) b.setAttribute('aria-label', label);
    });
    $$('[data-o-wish-count]').forEach(function(c){ c.textContent = w.length; c.hidden = !w.length; });
  }
  function toggleW(handle, btn){
    var w = getW(), i = w.indexOf(handle);
    if (i > -1) w.splice(i, 1); else w.push(handle);
    setW(w);
    // on the wishlist page, removing a heart removes the card
    var grid = $('[data-o-wish-grid]');
    if (grid && i > -1 && btn && grid.contains(btn)) {
      var li = btn.closest('.o-card'); if (li) li.remove();
      if (!grid.children.length) $('[data-o-wish-empty]').hidden = false;
    }
  }
  function renderWishlistPage(){
    var grid = $('[data-o-wish-grid]'); if (!grid) return;
    var empty = $('[data-o-wish-empty]');
    var handles = getW();
    if (!handles.length) { empty.hidden = false; return; }
    Promise.all(handles.map(function(h){
      return fetch(withSection(ROOT + 'products/' + encodeURIComponent(h), 'obliq-card-render'))
        .then(function(r){ return r.ok ? r.text() : ''; })
        .catch(function(){ return ''; });
    })).then(function(htmls){
      var keep = [];
      htmls.forEach(function(html, i){
        if (!html) return;
        var li = parse(html).querySelector('.o-card');
        if (!li) return;
        li.classList.add('is-in');
        grid.appendChild(li);
        keep.push(handles[i]);
      });
      if (keep.length !== handles.length) setW(keep); // drop products that no longer exist
      syncW();
      if (!grid.children.length) empty.hidden = false;
    });
  }

  // ---------- quick view ----------
  var qv = $('#OQuickView');
  function openQuickView(url){
    if (!qv) { window.location.href = url; return; }
    var body = $('[data-o-qv-body]', qv);
    body.innerHTML = '<div class="o-qv__loading">Loading</div>';
    openDialog(qv);
    fetch(withSection(url, 'obliq-quick-view'))
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        var root = parse(html).querySelector('[data-o-qv-root]');
        if (!root) throw new Error('no content');
        body.innerHTML = '';
        body.appendChild(root);
        var btn = $('button[type=submit]', root); if (btn) btn.focus();
      })
      .catch(function(){ window.location.href = url; });
  }

  // ---------- add to cart + popup ----------
  var added = $('#OAdded');
  function refreshCart(sections){
    if (!sections) return;
    var drawer = $('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      var cur = $('#CartDrawer', drawer);
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        var inner = $('.drawer__inner', drawer); if (inner) inner.classList.remove('is-empty');
        var ov = $('#CartDrawer-Overlay', drawer); if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
  }
  function showAdded(item, error){
    if (!added) return;
    var title = $('#OAddedTitle', added);
    var body = $('[data-o-added-body]', added);
    var actions = $('[data-o-added-actions]', added);
    if (error) {
      title.textContent = title.getAttribute('data-error');
      body.innerHTML = '<p class="o-added__error">' + esc(error) + '</p>';
      actions.hidden = true;
    } else {
      title.textContent = title.getAttribute('data-ok');
      var img = item.image ? '<img src="' + esc(item.image.split('?')[0]) + '?width=160" alt="" width="64" height="80" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">' : '';
      body.innerHTML =
        '<div class="o-added__item">' +
          '<div class="o-slot">' + img + '</div>' +
          '<div><p class="o-added__name">' + esc(item.product_title) + '</p>' +
          '<p class="o-added__meta">' + rupees(item.final_price) + ' · Qty ' + esc(item.quantity) + '</p></div>' +
        '</div>';
      actions.hidden = false;
    }
    closeDialog(qv);
    openDialog(added);
    var focusEl = $('[data-o-view-cart]', added); if (focusEl && !error) focusEl.focus();
  }
  function addToCart(form){
    var btn = $('button[type=submit]', form);
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    var spinner = $('.loading__spinner', btn);
    btn.setAttribute('aria-disabled', 'true');
    if (spinner) spinner.classList.remove('hidden');
    var fd = new FormData(form);
    var qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(fd.get('id')), quantity: qty }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function(r){ return r.json(); })
      .then(function(data){
        if (data.status) { showAdded(null, data.description || data.message || 'Please try again.'); return; }
        refreshCart(data.sections);
        var item = (data.items && data.items[0]) || data;
        // show the line's total quantity in the cart for this product
        showAdded(item, null);
      })
      .catch(function(){ showAdded(null, 'Please check your connection and try again.'); })
      .finally(function(){ btn.removeAttribute('aria-disabled'); if (spinner) spinner.classList.add('hidden'); });
  }

  // ---------- events ----------
  document.addEventListener('click', function(e){
    var t = e.target;
    var wish = t.closest('[data-o-wish]');
    if (wish) { e.preventDefault(); toggleW(wish.getAttribute('data-o-wish'), wish); return; }
    var q = t.closest('[data-o-qv]');
    if (q) { e.preventDefault(); openQuickView(q.getAttribute('data-o-qv')); return; }
    var close = t.closest('[data-o-modal-close]');
    if (close) { closeDialog(close.closest('.o-modal')); return; }
    if (t.closest('[data-o-view-cart]')) {
      closeDialog(added);
      var drawer = $('cart-drawer');
      if (drawer && drawer.open) drawer.open(); else window.location.href = ROOT + 'cart';
      return;
    }
    var step = t.closest('[data-o-qv-step]');
    if (step) {
      var input = $('input[name=quantity]', step.closest('form'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-o-qv-step'), 10));
    }
  });
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-o-add]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  syncW();
  renderWishlistPage();
  window.addEventListener('storage', function(e){ if (e.key === KEY) syncW(); }); // keep tabs in sync
})();
